import { useState } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { MatchTextArea } from 'foundations-components/transitional/components/MatchTextArea';
import { getContentTypeId, getModalLangKey } from 'ContentEditorUI/utils/contentManagementPanel/contentTableUtils';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DeleteContentModal = ({
  closeModal,
  content,
  deleteContent = () => {}
}) => {
  const [matchText, setMatchText] = useState('');
  const deleteMatchText = I18n.text('contentManagementPanel.modals.shared.delete.deleteMatchText');
  const contentTypeId = getContentTypeId(content);
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "delete-content-modal",
    use: "danger",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getModalLangKey('delete.header', contentTypeId)
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: closeModal
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "contentManagementPanel.modals.shared.delete.body",
        options: {
          name: content.name
        }
      }), /*#__PURE__*/_jsxs(View, {
        marginBlockStart: "600",
        as: "div",
        children: [/*#__PURE__*/_jsx(FormLabel, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: getModalLangKey('delete.deleteMatchLabel', contentTypeId),
            options: {
              deleteMatchText
            }
          })
        }), /*#__PURE__*/_jsx(MatchTextArea, {
          "data-test-id": "delete-match-text-input",
          match: deleteMatchText,
          onChange: e => setMatchText(e.target.value)
        })]
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        "data-test-id": "modal-confirm",
        disabled: matchText !== deleteMatchText,
        onClick: () => deleteContent(content),
        use: "danger",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "contentManagementPanel.modals.shared.delete.confirm"
        })
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "modal-cancel",
        onClick: closeModal,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "contentManagementPanel.modals.shared.cancel"
        })
      })]
    })]
  });
};
export default DeleteContentModal;